module.exports = __webpack_public_path__ + "img/dutch-bangla-bank.1d791c11.jpg";